import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StudentHallSweepSelectRequest } from "./StudentHallSweepSelectRequest";

@Injectable()
export class DataService_StudentHallSweep {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	StudentInfoSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "HallSweep/StudentInfoSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentHallSweepSelectList(parms: StudentHallSweepSelectRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/StudentHallSweepSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
